import { Button, Card, CardContent, Stack, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useState } from 'react';
import { executeShellCommand, type ShellFormat } from '../../api/shell';

export function ShellPanel() {
  const [command, setCommand] = useState('health');
  const [output, setOutput] = useState('Ready.');
  const [loading, setLoading] = useState(false);
  const [format, setFormat] = useState<ShellFormat>('text');

  async function handleRun() {
    if (!command.trim()) return;
    setLoading(true);
    try {
      const res = await executeShellCommand(command.trim(), format);
      setOutput(res);
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : 'Request failed';
      setOutput(`Error: ${msg}`);
    } finally {
      setLoading(false);
    }
  }

  function handleKeyDown(e: React.KeyboardEvent) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleRun();
    }
  }

  return (
    <Card sx={{ bgcolor: '#1a1d22' }}>
      <CardContent>
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Admin Shell</Typography>
            <ToggleButtonGroup
              value={format}
              exclusive
              onChange={(_, v) => { if (v) setFormat(v); }}
              size="small"
            >
              <ToggleButton value="text">Text</ToggleButton>
              <ToggleButton value="json">JSON</ToggleButton>
            </ToggleButtonGroup>
          </Stack>
          <Typography variant="body2" color="text.secondary">
            Commands: <code>health</code> <code>task.get</code> <code>task.list</code> <code>case.get</code>{' '}
            <code>case.bootstrap</code> <code>asset.get</code> <code>asset.list</code> <code>asset.dispatch</code>{' '}
            <code>save.get</code> <code>player.get</code> <code>audit.list</code>{' '}
            — Write commands require <code>--write</code> flag.
          </Typography>
          <Stack direction="row" spacing={2}>
            <TextField
              label="Command"
              value={command}
              onChange={(e) => setCommand(e.target.value)}
              onKeyDown={handleKeyDown}
              fullWidth
              size="small"
            />
            <Button variant="contained" onClick={handleRun} disabled={loading}>
              Run
            </Button>
          </Stack>
          <TextField
            value={output}
            fullWidth
            multiline
            minRows={8}
            slotProps={{ input: { readOnly: true, sx: { fontFamily: 'monospace', fontSize: '0.85rem', whiteSpace: 'pre' } } }}
          />
        </Stack>
      </CardContent>
    </Card>
  );
}
